import { TestimonialDetailsProps } from "./components/TestimonialDetails";
export const PARTNER_IMGS: string[] = [
  require("./assets/partner/vinfast.png"),
  require("./assets/partner/honda.png"),
  require("./assets/partner/LeBros.png"),
  require("./assets/partner/BIDV.png"),
  require("./assets/partner/hongbang.png"),
  require("./assets/partner/VTC online.png"),
  require("./assets/partner/Bảo Sơn.png"),
  require("./assets/partner/FPT.png"),
  require("./assets/partner/Steame Garten.png"),
  require("./assets/partner/tongcucquanlythitruong.png"),
  require("./assets/partner/NetNam.png"),
  require("./assets/partner/mobifone.png"),
];

export const TESTIMONIAL_DATA: TestimonialDetailsProps[] = [
  {
    src: require("./assets/DUYEN_HAI.jpg"),
    name: "Duyen Hai",
    title: "CEO Golden Palace",
    text: `Làm trong lĩnh vực nhà hàng và tiệc cưới,
        tôi liên tục có nhu cầu thiết kế nhanh và Express Design đã giúp tôi trong những trường hợp tưởng như không còn đủ thời gian để hoàn thành`,
  },
  {
    src: require("./assets/DIEM_MY.jpg"),
    name: "Diem My",
    title: "BSC PR Staff",
    text:
      "Tôi ấn tượng với dịch vụ tư vấn chính xác những gì tôi mong muốn, chỉ sau 5 phút đặt hàng trên Express Design",
  },
  {
    src: require("./assets/DO_HIEN.jpg"),
    name: "Minh Hien",
    title: "idigit Account Manager",
    text:
      "Đội ngũ của tôi rất tin tưởng vào không chỉ tay nghề mà cả tốc độ của Express Design. Thực sự là một lựa chọn chính xác cho dân Marcom",
  },
  {
    src: require("./assets/LEE_KAI.jpg"),
    name: "Lee Kai",
    title: "CCO FUJIWON",
    text:
      "Tôi thường rất khó tính với các mẫu thiết kế, nhưng các sản phẩm của Express Design luôn khiến tôi rất hài lòng",
  },
];



// WEBPACK FOOTER //
// ./src/routes/TestimonialsCarousel/constants.ts